import { createSelector } from 'reselect';

const selectAffiliators = (state: any) => state.affiliators;


export const selectAffiliatorsCurrentItem = createSelector([selectAffiliators], (affiliators) => affiliators.current);

export const selectAffiliatorsListItems = createSelector([selectAffiliators], (affiliators) => affiliators.list);

export const selectAffiliatorsItemById = (itemId: any) =>
    createSelector(selectAffiliatorsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectAffiliatorsQueryItems = createSelector([selectAffiliators], (affiliators) => affiliators.query);

export const selectAffiliatorsCreatedItem = createSelector([selectAffiliators], (affiliators) => affiliators.create);

export const selectAffiliatorsUpdatedItem = createSelector([selectAffiliators], (affiliators) => affiliators.update);

export const selectReadItem = createSelector([selectAffiliators], (affiliators) => affiliators.read);

export const selectAffiliatorsDeletedItem = createSelector([selectAffiliators], (affiliators) => affiliators.delete);

export const selectAffiliatorsearchedItems = createSelector([selectAffiliators], (affiliators) => affiliators.search);

export const selectAffiliatorsItemsCount = createSelector([selectAffiliators], (affiliators) => affiliators.count);

export const selectAffiliatorsItemsFilter = createSelector([selectAffiliators], (affiliators) => affiliators.filter);